export default {
  GET_CAMPAIGN_REPORT_WITH_CAMPAIGN_NAME:
    "GET_CAMPAIGN_REPORT_WITH_CAMPAIGN_NAME",
  GET_CAMPAIGNS_REPORT_WITH_CAMPAIGN_TYPE:
    "GET_CAMPAIGNS_REPORT_WITH_CAMPAIGN_TYPE",

  GET_REPORT_CAMPAIGN_SUCCESS: "GET_REPORT_CAMPAIGN_SUCCESS",
  GET_REPORT_CAMPAIGN_FAILED: "GET_REPORT_CAMPAIGN_FAILED",

  GET_CAMPAIGNS_REPORT_SUCCESS: "GET_CAMPAIGNS_REPORT_SUCCESS",
  GET_CAMPAIGNS_REPORT_FAILED: "GET_CAMPAIGNS_REPORT_FAILED",

  GET_DATA_CHART_SUCCESS: "GET_DATA_CHART_SUCCESS",
  GET_DATA_CHART_FAILED: "GET_DATA_CHART_FAILED",

  SET_DATE_REPORT_FILTER: "SET_DATE_REPORT_FILTER",

  GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_NAME:
    "GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_NAME",
  GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_TYPE:
    "GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_TYPE",

  SET_EVENT_DATA_CHART: "SET_EVENT_DATA_CHART",

  SET_TYPE_SEPARATION_DATA_CHART: "SET_TYPE_SEPARATION_DATA_CHART",

  GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_NAME:
    "GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_NAME",
  GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_TYPE:
    "GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_TYPE",

  GET_CAMPAIGNS_DATA_SEPARATION_SUCCESS:
    "GET_CAMPAIGNS_DATA_SEPARATION_SUCCESS",
  GET_CAMPAIGNS_DATA_SEPARATION_FAILED: "GET_CAMPAIGNS_DATA_SEPARATION_FAILED",
  EMPTY_CAMPAIGNS_DATA_SEPARATION_FAILED:
    "EMPTY_CAMPAIGNS_DATA_SEPARATION_FAILED",

  GET_CAMPAIGN_REPORT_PIE_CHART: "GET_CAMPAIGN_REPORT_PIE_CHART",
  GET_ALL_CAMPAIGN_REPORT_PIE_CHART: "GET_ALL_CAMPAIGN_REPORT_PIE_CHART",
  GET_ALL_CAMPAIGN_REPORT_LINE_CHART: "GET_ALL_CAMPAIGN_REPORT_LINE_CHART",
  GET_CAMPAIGN_REPORT_LINE_CHART: "GET_CAMPAIGN_REPORT_LINE_CHART",
  GET_REPORT_ALL_CAMPAIGN: "GET_REPORT_ALL_CAMPAIGN",
};
